// extracted by mini-css-extract-plugin
module.exports = {"top":"Reply_top__8npLE","avatar":"Reply_avatar__kQ7kC","name":"Reply_name__ALeAz","text":"Reply_text__xQbL0"};